import React, { useContext, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import ViewContainer from '../../common/components/Container/Container';
import { ValidationContext } from '../../providers/ValidationContext';
import { FlowConfigContext } from '../../providers/FlowConfigContext';
import Loading from '../../common/components/Loading/Loading';

function ValidationNextStepScreen(): JSX.Element {
  const { initialized } = useContext(FlowConfigContext);
  const { getRouteForNextStep } = useContext(ValidationContext);
  const navigate = useNavigate();

  const navigateToNextStep = async () => {
    const route = await getRouteForNextStep();
    if (route) navigate(route);
  };

  useEffect(() => {
    if (!initialized) {
      return;
    }

    navigateToNextStep();
  }, [initialized]);

  return (
    <ViewContainer>
      <div className="document-fixed-height flex h-screen justify-center items-center">
        <Loading dataTestId="IN_PROGRESS" />
      </div>
    </ViewContainer>
  );
}
export default ValidationNextStepScreen;
